import React from 'react'
import { Trans, useLingui } from '@lingui/react/macro'

import { Card } from '@newComponents/Card'
import { Paragraph } from '@newComponents/Text'
import { Link } from '@newComponents/Link'

import { DocSection } from '../shared/DocSection'
import { DocStep } from '../shared/DocStep'

const Embeds = () => {
  const { t } = useLingui()

  return (
    <>
      <Card gap='$4'>
        <Paragraph size='$5'>
          <Trans>
            User Embeds let you display your Guild profile on an external website.
            The embed widget shows your profile photo, display name, and a link to
            your full profile on Guild — perfect for personal websites, speaker
            pages, or team directories.
          </Trans>
        </Paragraph>
        <Paragraph size='$5'>
          <Trans>
            Like all Guild Embeds, user widgets load inside an iframe and are fully
            self-contained. They work on any website regardless of framework or CMS
            and automatically adapt to light and dark backgrounds.
          </Trans>
        </Paragraph>
        {/* TODO: Capture screenshot of User profile → Share/Embed dialog showing the user embed code */}
      </Card>

      <Card gap='$4'>
        <DocSection id='getting-user-embed-code' title={t`Getting the Embed Code`}>
          <Paragraph size='$5'>
            <Trans>
              To embed your profile on an external site, follow these steps.
            </Trans>
          </Paragraph>
          <DocStep
            number={1}
            title={t`Visit your profile page`}
            description={t`Navigate to your profile by clicking your profile photo in the top-right corner and selecting your name, or by visiting your profile URL directly.`}
          />
          <DocStep
            number={2}
            title={t`Open the share menu`}
            description={t`Click the Share button on your profile page to see sharing options, including the embed code.`}
          />
          <DocStep
            number={3}
            title={t`Copy the embed code`}
            description={t`Copy the provided HTML snippet. It contains a script tag and a container element that renders the profile widget on your site.`}
          />
          <DocStep
            number={4}
            title={t`Paste into your site`}
            description={t`Add the embed code to any HTML page, blog, or CMS content block. The widget loads automatically and links back to your full profile on Guild.`}
          />
        </DocSection>
      </Card>

      <Card gap='$4'>
        <DocSection id='user-embed-use-cases' title={t`When to Use User Embeds`}>
          <Paragraph size='$5'>
            <Trans>
              User Embeds are ideal for personal websites or portfolios where you want
              to link to your Guild profile, conference speaker pages where organizers
              list presenters, or company team pages that connect employees to their
              community profiles.
            </Trans>
          </Paragraph>
          <Paragraph size='$5'>
            <Trans>
              For embedding a Guild or its Events, see{' '}
              <Link href='/docs/guilds/embeds'>Guild Embeds</Link> and{' '}
              <Link href='/docs/events/embeds'>Event Embeds</Link>. For embedding
              individual Presentations, see{' '}
              <Link href='/docs/presentations/embeds'>Presentation Embeds</Link>.
            </Trans>
          </Paragraph>
        </DocSection>
      </Card>
    </>
  )
}

export default Embeds
